import { useSelector } from "react-redux";
import { RootState } from "../../../store/storeConfig";
import storeRTK from "../../../store/storeRTK";
import { setHistoryfilterCallbackCount } from "../../../actions/callback";
import { HistoryContainer } from "../../common/HistoryContainer/HistoryContainer";
import { Callback } from "../../../types/callback.type";

const CallbackHistory = () => {
  const history = useSelector((state: RootState) => state.history);
  const { callback } = history || {};

  return (
    <HistoryContainer<Callback>
      data={callback}
      type="callback"
      setCount={(count) =>
        storeRTK.dispatch(setHistoryfilterCallbackCount(count))
      }
      emptyTitle="No Callback history"
      emptyDescription="Wait for a callback"
    />
  );
};

export default CallbackHistory;
